import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export interface VerifyEmailRequest {
  token: string;
}

export interface VerifyEmailResponse {
  message: string;
}

/**
 * In-flight / settled verify calls keyed by token.
 * Survives React remounts (Strict Mode, refresh of the same page instance)
 * so concurrent verifyEmail calls cannot race and overwrite UI state.
 */
const verifyEmailByToken = new Map<string, Promise<VerifyEmailResponse>>();

/** Test helper — clears the verify dedupe cache. */
export function clearVerifyEmailDedupeCache(): void {
  verifyEmailByToken.clear();
}

export async function verifyEmail(payload: VerifyEmailRequest) {
  const token = payload.token;
  const existing = verifyEmailByToken.get(token);
  if (existing) {
    return existing;
  }

  const request = apiClient
    .post<VerifyEmailResponse>(env.authVerifyEmailPath, payload)
    .then(({ data }) => data)
    .catch((error: unknown) => {
      // Allow a later remount to retry after a failed attempt (e.g. network).
      verifyEmailByToken.delete(token);
      throw error;
    });

  verifyEmailByToken.set(token, request);
  return request;
}
